import React from 'react';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close.svg';
import Modal from 'src/Components/Modal';
import { formatCurrency } from '@wolffun/system-currency';
import icSuccess from 'assets/img/ic_success.png';
import Button from '../../Components/Button';

const TransactionSuccessModal = ({
  onClose,
  data
}) => {
  const {
    battle,
    feeInPercent,
    hero,
    price,
    priceAfterFee
  } = data;
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccess,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Complete!"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "You have successfully put up the hero #", hero.hero.tokenId, " -\xA0", hero.skin.name, "\xA0", hero.heroType.name, " for rent"), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Price"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatCurrency(price, {
    withCurrency: true
  }), "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Battles for rent"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, battle)), /*#__PURE__*/React.createElement("span", {
    className: styles.warning
  }, "You will receive\xA0", formatCurrency(priceAfterFee, {
    withCurrency: true
  }), " after subtracting a ", feeInPercent, "% fee"), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    title: "I got it",
    onClick: onClose
  })))));
};

export default TransactionSuccessModal;